import { buffers } from 'redux-saga';
import { take, takeEvery, put, select, actionChannel, flush } from 'redux-saga/effects';

import { AUTH_STATE_LOGIN } from '../../constants';
import { AUTH_FLOW_END, LOGOUT, FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED } from '../constants/actionTypes';

import { expireSoonPackageSubscriptionsSelector } from '../selector/user';

import {
  READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
  RESTORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
  STORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
} from '../reducers/user/readExpireSoonPackageSubscriptions';

const storageItemKey = 'readExpireSoonPackageSubscriptions';

function* storeReadExpireSoonSubscriptionFlow() {
  const expireSoonPackageSubscriptions = yield select(expireSoonPackageSubscriptionsSelector);

  yield put({
    type: STORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
    payload: expireSoonPackageSubscriptions,
  });

  try {
    localStorage.setItem(storageItemKey, JSON.stringify(expireSoonPackageSubscriptions));
  } catch {}
}

export function* syncExpireSoonPackageSubscriptionsFlow() {
  const queue = yield actionChannel(READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS, buffers.sliding(1));

  while (true) {
    const { payload } = yield take(AUTH_FLOW_END);

    if (payload === AUTH_STATE_LOGIN) {
      try {
        const readExpireSoonPackageSubscriptions = JSON.parse(localStorage.getItem(storageItemKey));

        if (readExpireSoonPackageSubscriptions?.every?.((id) => /\d+/.test(id))) {
          yield put({
            type: RESTORE_READ_EXPIRE_SOON_PACKAGE_SUBSCRIPTIONS,
            payload: readExpireSoonPackageSubscriptions,
          });
        }
      } catch {}

      yield take(FETCH_PRODUCT_SUBSCRIPTIONS_SUCCEEDED);

      yield takeEvery(queue, storeReadExpireSoonSubscriptionFlow);

      yield take(LOGOUT);

      try {
        localStorage.removeItem(storageItemKey);
      } catch {}
    }

    yield flush(queue);
  }
}
